document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".collection-load-more");
  if (!btn) return;

  e.preventDefault();

  const nextUrl = btn.getAttribute("data-next-url");
  if (!nextUrl) return;

  const originalText = btn.textContent;
  btn.textContent = "Cargando...";
  btn.setAttribute("aria-busy", "true");

  try {
    const res = await fetch(nextUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const newItems = doc.querySelectorAll("#product-grid > li");
    const grid = document.querySelector("#product-grid");

    if (!grid || newItems.length === 0) {
      btn.remove();
      return;
    }

    newItems.forEach((item) => grid.appendChild(item));

    const newBtn = doc.querySelector(".collection-load-more");
    if (newBtn && newBtn.getAttribute("data-next-url")) {
      btn.setAttribute("data-next-url", newBtn.getAttribute("data-next-url"));
      btn.setAttribute("href", newBtn.getAttribute("href"));
      btn.textContent = originalText;
      btn.removeAttribute("aria-busy");
    } else {
      btn.remove();
    }
    globoswatch?.init();
  } catch (err) {
    btn.textContent = "Error, intentá de nuevo";
    btn.removeAttribute("aria-busy");
  }
});